//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {};
  },
  methods: {},
  components: {},
  mounted() {
    console.log(this.controlItem, "controlItem===============");
  }
};
